var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row justify-center"},[_c('DelivSelector',{on:{"select":_vm.select}})],1),_c('v-btn',{staticClass:"text-capitalize my-2",on:{"click":function($event){return _vm.loadAll()}}},[_vm._v("Load All")]),_c('List'),_c('Detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }